import { useMemo } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Select } from "antd";
import CustomInput from "../../../CommonComponents/CustomInput/CustomInput";
import {
  formatTimezoneDisplay,
  getAvailableTimezones,
} from "../../../../utils/dateService";
import "./stylesPersonalInformation.css";
import { AppStrings } from "../../../../utils/constants/AppStrings";

function PersonalInformation({
  personalInfo,
  onPersonalInfoChange,
  onContinue,
}) {
  const timezoneOptions = useMemo(
    () =>
      getAvailableTimezones().map((timezone) => ({
        value: timezone,
        label: formatTimezoneDisplay(timezone),
      })),
    [],
  );

  const isFormValid =
    personalInfo.firstName &&
    personalInfo.lastName &&
    personalInfo.email;

  return (
    <div className="personal-information-container">
      <div className="step-content-header">
        <h3>{AppStrings.PERSONAL_INFORMATION}</h3>
        <InfoCircleOutlined className="info-icon" />
      </div>
      <div className="personal-info-form">
        <div className="form-row">
          <div className="form-field">
            <label>{AppStrings.FIRST_NAME}</label>
            <CustomInput
              placeholder="E.g. John"
              value={personalInfo.firstName}
              onChange={(e) =>
                onPersonalInfoChange("firstName", e.target.value)
              }
            />
          </div>
          <div className="form-field">
            <label>{AppStrings.LAST_NAME}</label>
            <CustomInput
              placeholder="E.g. Smith"
              value={personalInfo.lastName}
              onChange={(e) =>
                onPersonalInfoChange("lastName", e.target.value)
              }
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>{AppStrings.EMAIL}</label>
            <CustomInput
              placeholder="E.g. johnsmith@gmail.com"
              value={personalInfo.email}
              onChange={(e) =>
                onPersonalInfoChange("email", e.target.value)
              }
            />
          </div>
          <div className="form-field">
            <label>{AppStrings.SET_TIME_ZONE}</label>
            <Select
              className="personal-info-timezone-select"
              placeholder={AppStrings.NOT_SELECTED}
              value={personalInfo.timezone || null}
              onChange={(value) => onPersonalInfoChange("timezone", value)}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={timezoneOptions}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>Agent ID (Optional)</label>
            <CustomInput
              placeholder="E.g. AGENT-001"
              value={personalInfo.agentId || ""}
              onChange={(e) => onPersonalInfoChange("agentId", e.target.value)}
            />
          </div>
          <div className="form-field">
            <label>Position (Optional)</label>
            <CustomInput
              placeholder="E.g. Risk Analyst"
              value={personalInfo.position || ""}
              onChange={(e) => onPersonalInfoChange("position", e.target.value)}
            />
          </div>
        </div>

      </div>
      <div className="step-actions">
        <button
          className="continue-button"
          disabled={!isFormValid}
          onClick={onContinue}
        >
          {AppStrings.CONTINUE}
        </button>
      </div>
    </div>
  );
}

export default PersonalInformation;

